import React from 'react'

// TODO: this seems a bit random, move somewhere more central
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import type {
  AllPagesQuery,
  Image,
  LocaleString,
  StoriesQuery,
  StoriesQueryVariables,
} from '@/.generated/sanityTypes/graphql'
import type { GetStaticPropsContext, GetStaticPropsResult } from 'next/types'
import Card from '@/components/card'
import Layout from '@/components/layout'
import StoriesList from '@/components/storiesList'
import { useRouter } from 'next/router'
import { stories as storiesQuery } from './stories.sanity.graphql'
import { request } from '@/lib/sanityClient'
import { isLocalString } from '../lib/typeHelper'
import { getAllPages, getPageQueryVariables } from '@/lib/query'

type StoriesProps = {
  data: StoriesQuery
  messages: unknown
  isPreview: boolean
  allPages: AllPagesQuery
}

const Stories = ({ data, isPreview, allPages }: StoriesProps) => {
  const { locale = 'de' } = useRouter()
  const page = data?.allPage[0] ?? {}

  return (
    <Layout
      allPages={allPages}
      isPreview={isPreview}
      title={
        (isLocalString(page?.pageHeader?.sectionTitle) &&
          page?.pageHeader?.sectionTitle[locale as keyof LocaleString]) ||
        undefined
      }
      headerFiles={
        [
          ...(page?.image ? [page?.image] : []),
          ...(page?.additionalImages || []),
        ] as Image[]
      }
    >
      <Card headerData={page.pageHeader} contentData={page} />
      <StoriesList data={data} />
    </Layout>
  )
}

export async function getStaticProps(
  context: GetStaticPropsContext,
): Promise<GetStaticPropsResult<StoriesProps>> {
  const isPreview = context.preview || false
  const queryVariables = getPageQueryVariables('stories')
  const pageData = await request<StoriesQuery, StoriesQueryVariables>(
    storiesQuery,
    queryVariables,
    isPreview,
  )

  if (pageData.errors)
    throw new Error(`graphql Error occured: ${pageData.errors[0].message}`)

  return {
    props: {
      data: pageData.data,
      messages: (await import(`@/translation/${context.locale}.json`)).default,
      isPreview,
      allPages: await getAllPages(),
    },
  }
}

export default Stories
